import { createStore } from 'vuex'

import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import common from './modules/common'

export default createStore({
  modules: {
    app,
    settings,
    common,
    user
  },
  getters
})